import Circle from './assets/images/circle.svg';
import Square from './assets/images/square.svg';
import Triangle from './assets/images/triangle.svg';
import IronManBlack from './assets/images/iron-man-black-bg.png';
import IronManWhite from './assets/images/iron-man-white-bg.png';
import IronManNo from './assets/images/iron-man-no-bg.png';
import BhaagMilkha from './assets/images/bhaag-milkha.png';

export const ImageFilters = [
    {
        name: "Circle",
        value: "circle",
        srcImg: Circle
    },
    {
        name: "Square",
        value: "square",
        srcImg: Square
    },
    {
        name: "Triangle",
        value: "triangle",
        srcImg: Triangle
    },
    {
        name: "Bhaag Milkha",
        value: "bhaag-milkha",
        srcImg: BhaagMilkha
    },
    {
        name: "Iron Man Black Background",
        value: "iron-man-black-bg",
        srcImg: IronManBlack
    },
    {
        name: "Iron Man White Background",
        value: "iron-man-white-bg",
        srcImg: IronManWhite
    },
    {
        name: "Iron Man No Background",
        value: "iron-man-no-bg",
        srcImg: IronManNo
    }
];